export default __webpack_public_path__ + "static/media/1 (12).6e65d52b.png";